module.exports = __webpack_public_path__ + "img/planta_05.947bd146.png";